import React from 'react'
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material'

interface BreachDetectiveCommonProps {
  breachDetectiveData: any
}

function getBreachPhone(response: any) {
 
  if (response?.apiDataEntities && Array.isArray(response.apiDataEntities)) {
    for (const entity of response.apiDataEntities) {
      if ( (entity?.from === 'breach_phone' || entity.from === 'breach_email') && entity?.data?.breachDetective) {
        return entity.data.breachDetective
      }
    }
  }

  if (response?.breachDetective) {
    return response.breachDetective
  }

  return null
}

const Field = ({ label, value }: { label: string; value?: any }) => {
  const text = Array.isArray(value) ? value.filter(Boolean).join(', ') : value

  if (!text) return null

  return (
<Grid item xs={6}>
  <Grid
    container={text.length < 35}
    sx={{ display: 'flex', overflow: 'hidden' }}
  >
    <Grid item xs={4}>
      <Typography variant="text" fontSize={14} sx={{ wordBreak: 'break-all' }}>
        {label}:
      </Typography>
    </Grid>

    <Grid item xs={8}>
      <Typography
        variant="bold"
        sx={{ wordBreak: 'break-all', whiteSpace: 'pre-line' }}
      >
        {text}
      </Typography>
    </Grid>
  </Grid>
</Grid>
  )
}

const BreachDetective: React.FC<BreachDetectiveCommonProps> = ({ breachDetectiveData }) => {
  
  const filteredData = getBreachPhone(breachDetectiveData)
  if (!filteredData) return null

  const records = filteredData.records || []

  return (
    <Grid container spacing={1} sx={{ width: '100%' }}>
      {records.map((record: any, index: number) => {
        const data = record.availableData || {}

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
            )}

            <Field label="Source" value={record.breachSource} />
            <Field label="Date" value={record.breachDate} />

            <Field label="Email" value={data.email} />
            <Field label="Username" value={data.username} />

            <Field label="Phone" value={data.phone} />
            <Field label="Name" value={data.name} />

            <Field label="Address" value={data.address} />
            <Field label="Birthday" value={data.dateOfBirth} />

            <Field label="IP" value={data.ipAddress} />
          </React.Fragment>
        )
      })}
    </Grid>
  )
}

export default BreachDetective